import React from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import { baseDomain } from '../../common/config';

const ForbiddenPage: React.FC = () => {
  return (
    <PageWrapper title='Zugriff verweigert'>
      <div className='margin-vertical-xl align-center'>
        <h1 className='margin-none'>Hinweis Fehler 403</h1>
        <div>
          <img
            alt='errorImage'
            src='//www.static-immobilienscout24.de/statpic/error-page/1b897f0c0bc19ff74d68346f75fdef25_IS24_ErrorPage.svg'
            onError={() => "this.src='//etc/designs/is24/img/immoscout24.png';this.onerror=null;"}
            style={{ height: 200 }}
          />
          <p className='font-bold margin-bottom-s'>Sie sind nicht berechtigt, diese Seite anzusehen.</p>
          <a href={'//' + baseDomain()} className='button-primary margin-bottom-l'>
            Zur Startseite
          </a>
          <p>Vielen Dank für Ihr Verständnis!</p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ForbiddenPage;
